import Vue from 'vue';
import {request, setAuthInHeader} from "@/api/request";


Vue.prototype.$api = {
    $auth: { // 계정 로그인 / 회원가입 api
        login(params){ // 유저 로그인
            return request.post("member/login", params)
                .then(({data}) => data);
        },
    },
    $common: {


    },
    $member: {
        getMember(params) {
            return request.get(`member`,params).then(({data}) => data);
        },
        updateMember(params) {
            return request.post(`member/update`, params).then(({data}) => data);
        },
        quitMember(params) {
            return request.post(`member/delete`, params).then(({data}) => data);
        },
        getOutCategory(params) {
            return request.get(`member/out/category`, params).then(({data}) => data);
        },
    },
    $board: {
        getNotice(params) {
            return request.get(`board/notice`, params).then(({data}) => data);
        },
        createNotice(params) {
            return request.post(`board/notice`, params).then(({data}) => data);
        },
        updateNotice(params) {
            return request.post(`board/notice/update`, params).then(({data}) => data);
        },
        deleteNotice(params) {
            return request.post(`board/notice/delete`, params).then(({data}) => data);
        },
        getFaq(params) {
            return request.get(`faq`, params).then(({data}) => data);
        },
        createFaq(params) {
            return request.post(`faq`, params).then(({data}) => data);
        },
        updateFaq(params) {
            return request.post(`faq/update`, params).then(({data}) => data);
        },
        deleteFaq(params) {
            return request.post(`faq/delete`, params).then(({data}) => data);
        },
        getRefund(params) {
            return request.get(`refund/board`, params).then(({data}) => data);
        },
        createRefundAnswer(params) {
            return request.post(`refund/board`, params).then(({data}) => data);
        },
        updateRefundAnswer(params) {
            return request.post(`refund/board/update`, params).then(({data}) => data);
        },
        getQa(params) {
            return request.get(`qa`, params).then(({data}) => data);
        },
        createQaAnswer(params) {
            return request.post(`qa/answer`, params).then(({data}) => data);
        },
        updateQaAnswer(params) {
            return request.post(`qa/answer/update`, params).then(({data}) => data);
        },
    },
    $config: {
        getCountry(params) {
            return request.get(`country`, params).then(({data}) => data);
        },
        getConfig(params) {
            return request.get(`config`, params).then(({data}) => data);
        },
        createConfig(params) {
            return request.post(`config`, params).then(({data}) => data);
        },
        updateConfig(params) {
            return request.post(`config/update`, params).then(({data}) => data);
        },
        deleteConfig(params) {
            return request.post(`config/delete`, params).then(({data}) => data);
        },
    },
    $order: {
        getOrder(params) {
            return request.get(`order`, params).then(({data}) => data);
        }
    },
    $subscribe: {
        getSubscribe(params) {
            return request.get(`subscribe`, params).then(({data}) => data);
        },
        exitSubscribe(params) {
            return request.post(`subscribe/exit`, params).then(({data}) => data);
        },
    },
    $item: {
        getItem(params) {
            return request.get(`item`, params).then(({data}) => data);
        },
        createItem(params) {
            return request.post(`item`, params).then(({data}) => data);
        },
        updateItem(params) {
            return request.post(`item/update`, params).then(({data}) => data);
        },
        deleteItem(params) {
            return request.post(`item/delete`, params).then(({data}) => data);
        }
    },
    $popup:{
        getPopup(params) {
          return request.get(`event`, params).then(({data}) => data);
        },
        createPopup(params) {
            return request.post(`event`, params).then(({data}) => data);
        },
        updatePopup(params) {
            return request.post(`event/update`, params).then(({data}) => data);
        },
        deletePopup(params) {
            return request.post(`event/delete`, params).then(({data}) => data);
        },
    },
    $file: {
        editorUpload(params) {
            return request.post("file/editorUpload",params)
                .then(({data}) => data);
        },
        downLoad(params){
            return request.get(params)
                .then(({data}) => data);
        },
        updateFile(params) {
            return request.post(`file`, params).then(({data}) => data);
        },
        deleteFile(params) {
            return request.post("file/delete/"+params.a_idx)
                .then(({data}) => data);
        }
    },

    $handler: {
        authHeader : setAuthInHeader
    }
};

export default Vue.prototype.$api;


